import React, { useState, useEffect } from "react";
import "../Header.css";
import { NavLink, Link, useNavigate } from "react-router-dom";
import {
  FiMenu,
  FiX,
  FiChevronDown,
  FiArrowRight,
} from "react-icons/fi";

import logo from "../../assets/saivari-logo-1.png";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [industriesOpen, setIndustriesOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeAll = () => {
    setMenuOpen(false);
    setServicesOpen(false);
    setIndustriesOpen(false);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const navigate = useNavigate();


  return (
    <>
      <header className={`header ${scrolled ? "header-scrolled" : ""}`}>
        <div className="container header-container">

          {/* ==========================
                  LOGO
          ========================== */}

          <Link to="/" className="logo" onClick={closeAll}>
            <img src={logo} alt="Saivari Fintech" />
          </Link>

          {/* ==========================
                DESKTOP MENU
          ========================== */}

          <nav className="desktop-nav">

            <NavLink
              to="/"
              end
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }

              onClick={(e) => {
                e.preventDefault();
                window.location.href = "/";
              }}
            >
              Home
            </NavLink>

            <NavLink
              to="/about"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }


              onClick={(e) => {
                e.preventDefault();
                window.location.href = "/about";
              }}
            >
              About
            </NavLink>

            {/* SERVICES */}

            <div className="dropdown">

              <button className="dropdown-btn">
                Solutions
                <FiChevronDown />
              </button>

              <div className="dropdown-menu">

                <NavLink to="/fintech-consulting"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = "/fintech-consulting";
                  }}
                >
                  FinTech Consulting
                </NavLink>

                <NavLink to="/payment-solutions"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = "/payment-solutions";
                  }}
                >
                  Payment Solutions
                </NavLink>

                <NavLink to="/aml-managed"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = "/aml-managed";
                  }}
                >
                  AML Managed
                </NavLink>

                <NavLink to="/third-party-risk-management"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = "/third-party-risk-management";
                  }}
                >
                  Third Party Risk
                </NavLink>

                <NavLink to="/compliance-support"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = "/compliance-support";
                  }}
                >
                  Compliance Support
                </NavLink>


                <NavLink to="/kyc-verification"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = "/kyc-verification";
                  }}
                >
                  KYC Verification
                </NavLink>

              </div>
            </div>

            {/* INDUSTRIES */}

            <NavLink
              to="/industries"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }

              onClick={(e) => {
                e.preventDefault();
                window.location.href = "/industries";
              }}
            >
              Industries
            </NavLink>

            <NavLink
              to="/resources"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }

              onClick={(e) => {
                e.preventDefault();
                window.location.href = "/resources";
              }}
            >
              Resources
            </NavLink>


            {/* <NavLink
              to="/contact"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              Contact
            </NavLink> */}

          </nav>

          {/* ==========================
                  CTA
          ========================== */}

          <Link to="/contact" className="header-btn"

            onClick={(e) => {
              e.preventDefault();
              window.location.href = "/contact";
            }}
          >

            Let's Connect

            <FiArrowRight />

          </Link>

          {/* ==========================
               MOBILE ICON
          ========================== */}

          <button
            className="menu-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>

        {/* ==========================
            MOBILE MENU
        ========================== */}

        <div className={`mobile-menu ${menuOpen ? "show" : ""}`}>

          <NavLink to="/" end onClick={() => {
            closeAll();
            window.scrollTo(0, 0);
          }}>
            Home
          </NavLink>

          <NavLink to="/about" onClick={() => {
            closeAll();
            window.scrollTo(0, 0);
          }}>
            About
          </NavLink>

          {/* MOBILE SERVICES */}

          <button
            className="mobile-dropdown-btn"
            onClick={() => setServicesOpen(!servicesOpen)}
          >
            Solutions

            <FiChevronDown
              className={servicesOpen ? "rotate" : ""}
            />
          </button>

          <div
            className={`mobile-dropdown ${servicesOpen ? "open" : ""
              }`}
          >
            <NavLink
              to="fintech-consulting"
              onClick={() => {
                closeAll();
                window.scrollTo(0, 0);
              }}
            >
              FinTech Consulting
            </NavLink>

            <NavLink
              to="payment-solutions"
              onClick={() => {
                closeAll();
                window.scrollTo(0, 0);
              }}
            >
              Payment Solutions
            </NavLink>

            <NavLink
              to="/compliance-support"
              onClick={() => {
                closeAll();
                window.scrollTo(0, 0);
              }}
            >
              Compliance Support
            </NavLink>


            <NavLink to="/aml-managed"
              onClick={() => {
                closeAll();
                window.scrollTo(0, 0);
              }}
            >
              AML Managed
            </NavLink>

            <NavLink to="/third-party-risk-management"
              onClick={() => {
                closeAll();
                window.scrollTo(0, 0);
              }}
            >
              Third Party Risk
            </NavLink>

            <NavLink
              to="/kyc-verification"
              onClick={() => {
                closeAll();
                window.scrollTo(0, 0);
              }}
            >
              KYC Verification
            </NavLink>
          </div>

          {/* MOBILE INDUSTRIES */}

          <NavLink to="/industries" onClick={() => {
            closeAll();
            window.scrollTo(0, 0);
          }}>
            Industries
          </NavLink>

          <NavLink to="/resources" onClick={() => {
            closeAll();
            window.scrollTo(0, 0);
          }}>
            Resources
          </NavLink>



          {/* <NavLink to="/contact" onClick={closeAll}>
            Contact
          </NavLink> */}

          <Link
            to="/contact"
            className="mobile-btn"
            onClick={() => {
              closeAll();
              window.scrollTo(0, 0);
            }}
          >
            Let's Connect
          </Link>

        </div>

      </header>
    </>
  );
};

export default Header;